// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6ae6778e","453":"68ad9db7","732":"8e7de747","977":"d709178f"}[chunkId] + ".chunk.js";
};